import { fetchApi } from './api';
import type { SdsChatMessage, SdsChatResponse, SdsFeedbackPayload } from '../types/sdsAssistant';

export const sdsAssistantApi = {
    /** Ask the SDS assistant. Language is auto-detected from the question — no language param. */
    chat(messages: SdsChatMessage[]): Promise<SdsChatResponse> {
        return fetchApi<SdsChatResponse>('/sds-assistant/chat', {
            method: 'POST',
            body: JSON.stringify({ messages }),
        });
    },

    /** Thumbs up/down on an answer. */
    sendFeedback(payload: SdsFeedbackPayload): Promise<{ saved: boolean }> {
        return fetchApi<{ saved: boolean }>('/sds-assistant/feedback', {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    },
};
